import { create } from '@bufbuild/protobuf';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { maasApi } from '@/api/maas.api';
import { ListRequestSchema } from '@/proto/agentplatform/httpv2/common_pb';
import {
  type CreateMaasCredentialRequest,
  type UpdateMaasCredentialRequest,
} from '@/proto/agentplatform/httpv2/maas_pb';

const QK = ['maas-credentials', 'list'] as const;

export function useMaasCredentials(page = 1, pageSize = 10, enabled = true, name = '') {
  return useQuery({
    queryKey: [...QK, page, pageSize, name] as const,
    queryFn: () =>
      maasApi.listCredentials(create(ListRequestSchema, { page, pageSize, fuzzy: name ? { name } : {} })),
    enabled,
  });
}

export function useCreateMaasCredential() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateMaasCredentialRequest) => maasApi.createCredential(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: QK });
    },
  });
}

export function useUpdateMaasCredential() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: UpdateMaasCredentialRequest) => maasApi.updateCredential(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: QK });
    },
  });
}

export function useDeleteMaasCredential() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => maasApi.deleteCredential(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: QK });
    },
  });
}
